export const MODULE_IMPORT_ERROR =
  'TypeError: Importing a module script failed.'
export const IOS_SAFARI_MODULE_IMPORT_ERROR =
  'iOS Safari: module script import failed'
